<app-date-input #dateInputComponent [value]="_dateTime?.date" (changed)="handleDateChange()"></app-date-input>

<app-time-input #timeInputComponent [value]="_dateTime?.time" (changed)="handleTimeChange()"></app-time-input>
